import { render } from "./App.vue?vue&type=template&id=341523c9&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=341523c9&lang=sass"
import "./App.vue?vue&type=style&index=1&id=341523c9&lang=css"
import "./App.vue?vue&type=style&index=2&id=341523c9&lang=sass&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341523c9"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QPageContainer,QPage,QBadge,QStepper,QItem});
